import React from "react";
const MessageSquare = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="73"
    height="73"
    viewBox="0 0 73 73"
    fill="none"
    {...props}
  >
    <path
      d="M63.5 45.5C63.5 47.0913 62.8679 48.6174 61.7426 49.7426C60.6174 50.8679 59.0913 51.5 57.5 51.5H21.5L9.5 63.5V15.5C9.5 13.9087 10.1321 12.3826 11.2574 11.2574C12.3826 10.1321 13.9087 9.5 15.5 9.5H57.5C59.0913 9.5 60.6174 10.1321 61.7426 11.2574C62.8679 12.3826 63.5 13.9087 63.5 15.5V45.5Z"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MessageSquare;
